export default __webpack_public_path__ + "static/assets/im_theme.fd068264b95a26c92bf969eaf524ec25.png";